import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=ff35be86&scoped=true"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=ff35be86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff35be86",
  null
  
)

export default component.exports